function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M798.93 222.239H844.245C844.668 222.239 845.073 222.406 845.372 222.704C845.671 223.002 845.839 223.406 845.839 223.827V246.06C845.839 246.481 845.671 246.885 845.372 247.183C845.073 247.481 844.668 247.648 844.245 247.648H798.93C798.507 247.648 798.102 247.481 797.803 247.183C797.504 246.885 797.336 246.481 797.336 246.06V223.827C797.336 223.406 797.504 223.002 797.803 222.704C798.102 222.406 798.507 222.239 798.93 222.239Z",
  stroke: "#AADAF1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M823.234 196.781H868.524C868.947 196.781 869.353 196.949 869.652 197.247C869.951 197.544 870.119 197.948 870.119 198.369V220.603C870.119 221.024 869.951 221.428 869.652 221.726C869.353 222.024 868.947 222.191 868.524 222.191H823.234C822.811 222.191 822.405 222.024 822.106 221.726C821.807 221.428 821.639 221.024 821.639 220.603V198.369C821.639 197.948 821.807 197.544 822.106 197.247C822.405 196.949 822.811 196.781 823.234 196.781Z",
  stroke: "#AADAF1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M847.482 222.239H892.804C893.227 222.239 893.633 222.406 893.932 222.704C894.231 223.002 894.399 223.406 894.399 223.827V246.06C894.399 246.481 894.231 246.885 893.932 247.183C893.633 247.481 893.227 247.648 892.804 247.648H847.482C847.059 247.648 846.653 247.481 846.354 247.183C846.055 246.885 845.887 246.481 845.887 246.06V223.827C845.887 223.406 846.055 223.002 846.354 222.704C846.653 222.406 847.059 222.239 847.482 222.239Z",
  stroke: "#AADAF1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M775.392 247.743H820.738C821.161 247.743 821.567 247.911 821.866 248.209C822.165 248.506 822.333 248.91 822.333 249.332V271.565C822.333 271.986 822.165 272.39 821.866 272.688C821.567 272.986 821.161 273.153 820.738 273.153H775.392C774.969 273.153 774.563 272.986 774.264 272.688C773.965 272.39 773.797 271.986 773.797 271.565V249.332C773.797 248.91 773.965 248.506 774.264 248.209C774.563 247.911 774.969 247.743 775.392 247.743V247.743Z",
  stroke: "#AADAF1",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M862.959 504.706H886.553V527.789H862.959V504.706Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M951.61 504.039H975.212V527.114H951.61V504.039Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M821.113 57.6321L836.789 54.3607C837.867 54.1318 838.993 54.3374 839.919 54.9327C840.846 55.5279 841.498 56.4642 841.733 57.5369L848.184 87.3137C848.296 87.8409 848.302 88.385 848.202 88.9146C848.102 89.4443 847.898 89.949 847.602 90.3999C847.305 90.8507 846.922 91.2388 846.475 91.5418C846.027 91.8448 845.524 92.0567 844.994 92.1654L829.334 95.4448C828.256 95.6737 827.13 95.468 826.204 94.8728C825.277 94.2776 824.625 93.3413 824.39 92.2686L817.908 62.4917C817.796 61.9629 817.79 61.4173 817.891 60.8863C817.992 60.3553 818.197 59.8493 818.495 59.3976C818.793 58.946 819.177 58.5574 819.627 58.2544C820.076 57.9514 820.581 57.7399 821.113 57.6321Z",
  fill: "#9B9B9B"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M826.192 105.609C824.263 102.567 809.727 74.3072 814.232 71.9091C818.737 69.5111 821.249 72.0124 822.349 74.6089C824.741 72.0759 829.677 69.0505 831.718 71.258C834.11 73.791 832.125 77.8407 830.331 79.4208C832.38 78.7062 834.27 78.2853 835.912 80.5722C838.009 83.4149 835.314 91.5539 833.879 92.7767L841.454 99.9232C841.454 99.9232 828.114 108.618 826.192 105.609Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M955.485 279.783C955.485 267.428 967.876 257.415 983.17 257.415C998.463 257.415 1010.85 267.428 1010.85 279.783C1010.85 292.139 998.455 302.152 983.17 302.152C967.884 302.152 955.485 292.139 955.485 279.783Z",
  fill: "#BF9111"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M931.676 24.6155C952.989 24.6155 963.57 43.9268 964.591 50.6365C965.612 57.3463 964.296 71.4803 966.186 77.1419C971.432 92.5465 990.537 100.876 990.537 116.463C990.537 152.529 950.669 142.087 938.541 141.627C926.413 141.166 894.487 140.15 894.487 118.512C894.487 109.904 900.363 109.904 900.467 98.7083C900.555 89.2432 895.244 86.5673 895.244 63.8892C895.3 54.6147 907.938 24.5044 931.676 24.6155Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M901.783 212.234C901.208 206.072 897.477 143.945 916.247 118.536C915.623 116.478 915.162 114.376 914.867 112.247C907.986 117.186 882.255 143.215 878.986 147.542C876.012 143.779 843.965 99.0577 842.371 98.5257C840.776 97.9937 825.116 105.235 824.773 106.895C824.43 108.555 862.919 182.465 872.615 185.577C876.681 186.88 882.422 182.886 884.217 182.306C884.464 186.276 848.558 290.297 882.829 291.091C903.202 265.784 902.349 218.364 901.783 212.234Z",
  fill: "#F7D167"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M893.267 231.108L845.56 507.596L887.709 507.422L919.014 375.165L934.674 509.653L975.1 509.137L977.867 231.458L893.267 231.108Z",
  fill: "#3B4161"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M956.211 237.707C951.833 238.636 896.823 237.524 891.799 234.737C886.776 231.95 887.813 222.921 900.196 219.872C895.81 218.784 886.497 213.464 899.056 211.598C901.296 189.246 891.568 107.419 930.248 105.99C957.59 101.98 962.143 125.889 962.143 125.889C962.143 125.889 960.588 236.778 956.211 237.707Z",
  fill: "#6367FD"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M930.241 34.9382C915.545 34.9382 903.632 48.7308 903.632 65.7394C903.632 82.7479 915.545 96.5088 930.241 96.5088C936.453 96.4119 942.391 93.9416 946.826 89.6085C946.276 81.8903 946.204 74.0531 947.4 69.9558C949.25 64.8739 948.58 67.0019 946.682 66.7796L948.349 65.3662C948.349 61.8326 948.939 64.2466 952.487 64.2466L956.697 64.0719C955.972 47.8574 944.434 34.9382 930.241 34.9382Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M899.861 60.3478C905.554 58.855 910.011 56.1155 914.923 47.4048C920.776 52.7646 925.751 52.8678 934.443 51.1686C933.932 55.4009 933.518 60.189 939.107 60.7607C944.697 61.3324 961.218 68.4948 961.218 68.4948L960.421 49.7234L945.837 33.4454L928.805 30.3486L913.791 37.36L904.414 49.4773C904.414 49.4773 894.2 61.8009 899.861 60.3478Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M937.592 62.7935C937.592 60.5094 938.272 58.2766 939.546 56.3772C940.82 54.4778 942.63 52.9969 944.749 52.1218C946.867 51.2466 949.199 51.0165 951.448 51.4603C953.698 51.9042 955.766 53.0022 957.389 54.6156C959.013 56.229 960.119 58.2854 960.57 60.5249C961.02 62.7645 960.794 65.0868 959.919 67.1983C959.045 69.3098 957.562 71.1158 955.657 72.3882C953.752 73.6606 951.511 74.3422 949.218 74.3469C947.692 74.3511 946.18 74.0553 944.769 73.4764C943.359 72.8976 942.076 72.0471 940.996 70.9737C939.916 69.9004 939.06 68.6253 938.475 67.2215C937.891 65.8178 937.591 64.313 937.592 62.7935Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M926.206 92.2765C927.33 97.7316 926.413 104.799 925.082 109.841C929.013 112.08 944.753 112.85 949.537 109.42C947.711 102.774 944.928 78.4521 947.408 69.9637C941.164 69.4238 925.082 86.8135 926.206 92.2765Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M956.888 259.654C955.173 262.466 953.31 265.185 951.307 267.801C951.307 267.801 946.068 266.15 944.633 268.063C943.198 269.977 933.621 282.039 938.326 286.144C943.03 290.249 948.309 279.998 949.792 278.664C954.675 283.094 959.279 287.819 963.578 292.814C963.578 292.814 963.539 285.596 964.336 283.055C965.133 280.514 970.045 273.733 971.688 271.938C973.33 270.144 959.584 255.144 956.888 259.654Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M951.219 109.881C948.723 116.154 945.741 122.284 938.015 126.778C937.576 133.805 944.163 230.131 949.624 240.105C951.834 244.014 954.58 247.597 957.782 250.753C956.099 255.247 954.592 259.321 955.214 260.623C956.011 262.322 969.862 274.122 971.735 273.606C972.963 273.272 976.448 269.683 979.382 266.459C992.937 274.241 1005.45 279.783 1005.7 287.049C1005.7 292.242 1003.94 293.87 1001.8 296.371C1004.89 294.847 1012.31 287.057 1012.47 277.473C1012.67 265.387 1000.97 244.25 998.918 238.89C1002.74 234.57 1016.1 216.267 1019.25 200.18C1011.17 168.902 979.231 110.746 951.219 109.881Z",
  fill: "#F7D167"
}), /*#__PURE__*/React.createElement("path", {
  d: "M961.226 167.187C963.969 171.531 983.018 200.156 983.018 200.156C983.018 200.156 965.165 236.627 958.986 249.332",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1010.65 219.062C1007.3 217.437 1004.51 214.852 1002.63 211.637C1000.76 208.423 999.891 204.725 1000.14 201.017C1000.39 197.309 1001.74 193.758 1004.03 190.82C1006.31 187.882 1009.42 185.689 1012.97 184.521",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M989.628 193.796L983.01 200.148",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M991.183 203.904L983.01 199.68",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M959.225 253.612C961.075 255.708 972.78 263.99 975.969 265.34",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M861.89 173.405C863.643 171.589 865.9 170.337 868.372 169.808C870.844 169.279 873.419 169.498 875.765 170.437C878.112 171.376 880.123 172.991 881.541 175.076C882.958 177.161 883.718 179.621 883.722 182.139V182.433",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.946 147.527L872.4 157.222",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M884.783 155.149L879.145 147.36",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M847.322 104.537L829.031 116.138",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M918.966 375.292C917.818 367.542 913.448 301.199 916.526 278.108",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M963.993 393.055L976.28 388.179L963.06 379.969",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M901.783 395.318L914.676 393.42L906.288 384.447",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M890.269 248.474C894.255 249.014 932.529 251.118 957.247 249.927",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M848.255 491.826L891.664 490.604",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M932.92 494.828L975.236 493.629",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M949.656 278.775L967.342 296.554",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M938.956 268.024L942.265 271.343",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M947.169 509.494L934.865 250.261",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.143 331.865L873.468 507.477",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M925.082 65.6282C925.082 64.0401 925.735 62.7935 926.549 62.7935C927.362 62.7935 928.024 64.0639 928.024 65.6282C928.024 67.1925 927.362 68.455 926.549 68.455C925.735 68.455 925.082 67.1846 925.082 65.6282Z",
  fill: "#B5545C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M908.225 65.6282C908.225 64.0401 908.887 62.7935 909.7 62.7935C910.514 62.7935 911.168 64.0639 911.168 65.6282C911.168 67.1925 910.514 68.455 909.7 68.455C908.887 68.455 908.225 67.1846 908.225 65.6282Z",
  fill: "#B5545C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.629 66.1523C916.869 68.3597 916.39 73.2987 914.716 75.4585",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M927.482 79.8417C927.556 80.1324 927.593 80.4311 927.593 80.731C927.597 81.3016 927.46 81.8644 927.195 82.3704C926.931 82.8764 926.546 83.3104 926.074 83.6344C925.602 83.9585 925.058 84.1629 924.489 84.2298C923.92 84.2967 923.344 84.2241 922.809 84.0184",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M926.581 96.1912C927.791 96.3855 929.015 96.4838 930.24 96.485C933.408 96.4807 936.54 95.8153 939.434 94.5316",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M942.041 61.4039C942.261 59.9918 942.883 58.6719 943.833 57.6009C944.782 56.5299 946.021 55.7526 947.401 55.3611C948.781 54.9697 950.245 54.9805 951.619 55.3923C952.993 55.8041 954.219 56.5996 955.153 57.6846C956.087 58.7695 956.689 60.0984 956.887 61.5136C957.086 62.9288 956.873 64.371 956.273 65.6692C955.674 66.9675 954.713 68.0673 953.505 68.8383C952.297 69.6093 950.892 70.0192 949.457 70.0193C948.739 70.0165 948.026 69.915 947.336 69.7176",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M997.427 240.51L980.802 264.331",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M989.158 29.5148H998.359C998.79 29.5148 999.157 30.023 999.157 30.6503V36.3595C999.157 36.9868 998.798 37.4871 998.359 37.4871H989.158C988.727 37.4871 988.36 36.9868 988.36 36.3595V30.6503C988.368 30.023 988.727 29.5148 989.158 29.5148Z",
  fill: "#3BB2AC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1003.13 33.8662V37.3759C1003.13 37.4791 1003.06 37.5188 1002.98 37.4712L999.914 35.7322L996.86 33.9774C996.773 33.9297 996.773 33.8503 996.86 33.8027L999.914 32.0399L1002.98 30.2851C1002.99 30.2742 1003.01 30.2679 1003.03 30.2669C1003.05 30.2659 1003.06 30.2703 1003.08 30.2796C1003.1 30.2888 1003.11 30.3025 1003.12 30.319C1003.13 30.3355 1003.13 30.354 1003.13 30.3724V33.8662Z",
  fill: "#3BB2AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.197 33.501C982.197 30.8311 982.992 28.2213 984.481 26.0014C985.971 23.7815 988.088 22.0513 990.565 21.0297C993.042 20.008 995.767 19.7406 998.397 20.2615C1001.03 20.7823 1003.44 22.068 1005.34 23.9558C1007.23 25.8437 1008.52 28.2489 1009.05 30.8675C1009.57 33.486 1009.3 36.2002 1008.28 38.6667C1007.25 41.1333 1005.51 43.2416 1003.28 44.7248C1001.05 46.2081 998.433 46.9998 995.752 46.9998C992.157 46.9998 988.709 45.5776 986.167 43.0461C983.625 40.5146 982.197 37.0811 982.197 33.501Z",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M805.245 0.794052H999.452C1004.68 0.794052 1009.7 2.86377 1013.4 6.54788C1017.1 10.232 1019.18 15.2287 1019.18 20.4388V118.957C1019.18 124.167 1017.1 129.163 1013.4 132.848C1009.7 136.532 1004.68 138.601 999.452 138.601H805.245C800.014 138.601 794.996 136.532 791.296 132.848C787.597 129.163 785.519 124.167 785.519 118.957V20.4388C785.519 15.2287 787.597 10.232 791.296 6.54788C794.996 2.86377 800.014 0.794052 805.245 0.794052V0.794052Z",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1017.93 13.3956H786.994",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M799.704 7.32114C799.704 6.76799 799.869 6.22728 800.177 5.76747C800.486 5.30765 800.925 4.94941 801.438 4.73809C801.952 4.52678 802.516 4.47189 803.061 4.58038C803.606 4.68888 804.106 4.95587 804.498 5.34756C804.89 5.73925 805.157 6.23802 805.264 6.78073C805.372 7.32344 805.315 7.88568 805.101 8.39627C804.888 8.90686 804.527 9.34284 804.064 9.649C803.601 9.95517 803.058 10.1178 802.502 10.1162C802.134 10.1162 801.77 10.0438 801.43 9.90328C801.09 9.76272 800.781 9.55671 800.521 9.29706C800.261 9.03741 800.055 8.72922 799.914 8.39016C799.774 8.05109 799.703 7.68781 799.704 7.32114Z",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M810.763 7.32114C810.763 6.76833 810.928 6.22793 811.236 5.76828C811.545 5.30864 811.983 4.95039 812.496 4.73884C813.009 4.52729 813.573 4.47194 814.117 4.57978C814.662 4.68763 815.162 4.95384 815.555 5.34473C815.947 5.73563 816.214 6.23366 816.323 6.77585C816.431 7.31803 816.375 7.88003 816.163 8.39076C815.951 8.90149 815.591 9.33801 815.129 9.64514C814.668 9.95226 814.125 10.1162 813.57 10.1162C812.826 10.1162 812.112 9.82171 811.585 9.29754C811.059 8.77336 810.763 8.06243 810.763 7.32114Z",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M821.831 7.32113C821.831 6.76832 821.995 6.22793 822.304 5.76828C822.612 5.30864 823.05 4.95039 823.563 4.73884C824.076 4.52729 824.64 4.47194 825.185 4.57978C825.729 4.68763 826.23 4.95384 826.622 5.34473C827.015 5.73563 827.282 6.23366 827.39 6.77585C827.498 7.31803 827.443 7.88002 827.23 8.39075C827.018 8.90148 826.658 9.33801 826.197 9.64514C825.735 9.95226 825.193 10.1162 824.637 10.1162C824.269 10.1172 823.903 10.0457 823.562 9.90556C823.221 9.76547 822.911 9.55963 822.65 9.29987C822.39 9.04012 822.183 8.73158 822.042 8.39199C821.901 8.05241 821.83 7.68848 821.831 7.32113V7.32113Z",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M951.61 518.284L975.212 518.086L974.981 551.626L902.022 551.166C902.301 544.265 915.72 532.005 932.082 529.576C948.444 527.146 951.61 520.476 951.61 518.284Z",
  fill: "#9B9B9B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M915.25 535.793C918.209 538.326 920.789 541.268 922.913 544.528",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M926.333 531.426C929.296 533.955 931.877 536.897 933.996 540.16",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M932.314 530.735C911.686 508.557 951.092 502.888 932.385 530.735",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M932.473 530.695C954.496 504.785 967.055 547.712 932.473 530.775",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M975.196 523.906H947.966",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M975.005 551.531L902.357 551.166",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M862.959 518.959L886.553 518.761L886.322 552.301L813.371 551.864C813.65 544.964 827.069 532.704 843.431 530.274C859.793 527.845 862.959 521.151 862.959 518.959Z",
  fill: "#9B9B9B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M826.575 536.468C829.534 539.001 832.114 541.942 834.238 545.202",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M837.658 532.101C840.621 534.63 843.202 537.572 845.321 540.835",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M843.639 531.402C823.011 509.232 862.417 503.562 843.71 531.402",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M843.79 531.37C865.813 505.452 878.364 548.386 843.79 531.45",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M886.513 524.581H859.283",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M886.322 552.206L813.666 551.865",
  stroke: "#4E4242",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M818.019 88.9891C816.951 86.4641 817.421 76.8958 823.25 73.7196L818.019 88.9891Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M818.019 88.9891C816.951 86.4641 817.421 76.8958 823.25 73.7196",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M825.865 92.0463C825.211 88.8701 826.918 82.1921 830.386 79.8338L825.865 92.0463Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M825.865 92.0463C825.211 88.8701 826.918 82.1921 830.386 79.8338",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M938.118 126.722C943.253 122.871 949.082 115.487 951.092 110.206",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.023 220.611C919.085 223.859 937.026 222.723 945.797 221.746",
  stroke: "#4C4FD9",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.26,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M805.349 0.794052H999.571C1004.8 0.794052 1009.82 2.86377 1013.52 6.54788C1017.22 10.232 1019.3 15.2287 1019.3 20.4388V118.957C1019.3 124.167 1017.22 129.163 1013.52 132.848C1009.82 136.532 1004.8 138.601 999.571 138.601H805.349C800.117 138.601 795.1 136.532 791.4 132.848C787.701 129.163 785.622 124.167 785.622 118.957V20.4388C785.622 15.2287 787.701 10.232 791.4 6.54788C795.1 2.86377 800.117 0.794052 805.349 0.794052Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.675 240.991C243.675 235.191 252.81 230.499 264.07 230.499C275.33 230.499 284.464 235.191 284.464 240.991C284.464 246.791 275.33 251.474 264.07 251.474C252.81 251.474 243.675 246.799 243.675 240.991Z",
  fill: "#BBC8D4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M211.807 484.775L217.996 504.683L243.675 498.824L241.157 473.508L211.807 484.775Z",
  fill: "#3BB2AC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143.649 243.336H534.192C535.193 243.336 536.152 243.734 536.86 244.441C537.568 245.148 537.965 246.107 537.965 247.107V253.93C537.965 254.93 537.568 255.889 536.86 256.596C536.152 257.303 535.193 257.7 534.192 257.7H143.649C142.648 257.7 141.689 257.303 140.981 256.596C140.273 255.889 139.876 254.93 139.876 253.93V247.107C139.876 246.107 140.273 245.148 140.981 244.441C141.689 243.734 142.648 243.336 143.649 243.336Z",
  fill: "#DAE3EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196.817 258.041L117.808 500.129",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.937 258.041L181.962 500.129",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.937 258.041L339.902 500.129",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196.817 258.041L275.782 500.129",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.157 460.5L117.842 479.265L140.858 489.117L151.102 470.147L126.157 460.5Z",
  fill: "#3BB2AC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.313 477.534L141.643 488.059C141.643 488.059 171.966 516.446 185.958 523.363C185.915 529.667 185.104 532.592 180.255 534.392C178.087 535.194 138.894 519.516 138.894 519.516L132.321 512.471L106.966 500.819L117.313 477.534Z",
  fill: "#6A3416"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.005 472.586C132.005 471.974 132.187 471.375 132.527 470.866C132.868 470.357 133.352 469.96 133.918 469.726C134.484 469.492 135.107 469.43 135.708 469.55C136.309 469.669 136.862 469.964 137.295 470.397C137.728 470.83 138.024 471.382 138.143 471.982C138.263 472.583 138.201 473.206 137.967 473.771C137.732 474.337 137.335 474.821 136.825 475.161C136.316 475.501 135.717 475.683 135.104 475.683C134.697 475.684 134.293 475.605 133.917 475.449C133.54 475.294 133.198 475.066 132.91 474.778C132.622 474.491 132.394 474.149 132.239 473.773C132.083 473.397 132.004 472.993 132.005 472.586V472.586Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.284 476.621C120.284 476.007 120.466 475.406 120.808 474.895C121.15 474.384 121.636 473.986 122.204 473.752C122.772 473.517 123.398 473.456 124.001 473.576C124.604 473.697 125.157 473.994 125.592 474.429C126.026 474.864 126.321 475.418 126.44 476.021C126.559 476.623 126.496 477.248 126.26 477.815C126.023 478.382 125.624 478.867 125.111 479.207C124.599 479.547 123.998 479.728 123.383 479.726C122.56 479.724 121.772 479.395 121.191 478.813C120.61 478.231 120.284 477.443 120.284 476.621V476.621Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.35 482.071C136.35 481.459 136.532 480.86 136.872 480.351C137.213 479.842 137.697 479.445 138.263 479.211C138.829 478.976 139.453 478.915 140.054 479.035C140.655 479.154 141.207 479.449 141.64 479.882C142.074 480.315 142.369 480.867 142.488 481.467C142.608 482.068 142.547 482.69 142.312 483.256C142.078 483.822 141.68 484.306 141.171 484.646C140.661 484.986 140.062 485.168 139.449 485.168C138.627 485.168 137.839 484.841 137.258 484.261C136.677 483.68 136.35 482.893 136.35 482.071Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.054 496.341L129.871 507.37C130.516 507.651 131.023 508.176 131.282 508.83C131.541 509.483 131.531 510.213 131.254 510.859L129.085 515.729C128.94 516.046 128.734 516.33 128.478 516.566C128.223 516.803 127.923 516.987 127.596 517.107C127.269 517.228 126.922 517.282 126.574 517.268C126.226 517.254 125.884 517.172 125.568 517.026L100.735 505.997C100.415 505.86 100.125 505.66 99.8825 505.411C99.6398 505.162 99.4488 504.867 99.3203 504.544C99.1919 504.22 99.1285 503.875 99.1339 503.527C99.1392 503.179 99.2132 502.836 99.3516 502.517L101.511 497.646C101.658 497.328 101.865 497.041 102.123 496.803C102.38 496.565 102.682 496.38 103.011 496.258C103.341 496.137 103.69 496.082 104.041 496.096C104.392 496.11 104.736 496.194 105.054 496.341Z",
  fill: "#3C1B09"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.0786 280.918C119.601 265.01 200.684 273.821 218.176 298.088C224.425 306.754 222.308 320.316 220.737 325.425C219.166 330.535 153.023 472.322 153.023 472.322L123.366 461.054L152.51 345.905C152.51 345.905 56.0528 282.88 63.0786 280.918Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.866 465.038L168.005 355.125",
  stroke: "#8D8D8D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.345 449.232L158.17 461.174",
  stroke: "#8D8D8D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.484 502.85L242.975 495.582C242.975 495.582 284.439 498.337 299.651 494.823C303.621 499.728 304.876 502.5 302.212 506.969C301.043 508.957 260.783 521.657 260.783 521.657L251.23 520.369L224.263 527.423L217.484 502.85Z",
  fill: "#6A3416"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.934 525.171L246.125 517.981C246.459 517.885 246.809 517.855 247.155 517.893C247.5 517.932 247.835 518.038 248.139 518.206C248.444 518.374 248.712 518.601 248.929 518.872C249.146 519.144 249.307 519.455 249.403 519.789L250.821 524.907C250.909 525.244 250.931 525.594 250.883 525.939C250.836 526.284 250.721 526.616 250.545 526.917C250.369 527.217 250.135 527.48 249.857 527.689C249.579 527.899 249.263 528.052 248.925 528.14L222.734 535.33C222.4 535.427 222.05 535.456 221.705 535.418C221.359 535.379 221.025 535.273 220.72 535.105C220.416 534.937 220.147 534.711 219.931 534.439C219.714 534.167 219.553 533.856 219.456 533.522L218.039 528.404C217.95 528.068 217.929 527.717 217.976 527.372C218.024 527.027 218.139 526.695 218.315 526.395C218.491 526.094 218.725 525.832 219.003 525.622C219.28 525.412 219.597 525.259 219.934 525.171Z",
  fill: "#3C1B09"
}), /*#__PURE__*/React.createElement("path", {
  d: "M228.872 493.936C228.871 493.321 229.052 492.72 229.392 492.208C229.733 491.696 230.218 491.297 230.787 491.061C231.355 490.825 231.98 490.763 232.584 490.882C233.187 491.002 233.742 491.297 234.177 491.732C234.612 492.167 234.908 492.721 235.028 493.324C235.147 493.927 235.085 494.552 234.849 495.12C234.613 495.687 234.213 496.172 233.701 496.513C233.188 496.853 232.587 497.034 231.971 497.032C231.149 497.032 230.361 496.706 229.78 496.125C229.199 495.545 228.872 494.757 228.872 493.936Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.43 483.922C234.428 483.308 234.609 482.706 234.95 482.194C235.291 481.682 235.776 481.283 236.344 481.047C236.912 480.811 237.538 480.749 238.141 480.868C238.745 480.988 239.299 481.284 239.734 481.718C240.17 482.153 240.466 482.707 240.585 483.31C240.705 483.913 240.643 484.538 240.406 485.106C240.17 485.674 239.771 486.158 239.258 486.499C238.746 486.839 238.144 487.02 237.529 487.019C236.708 487.016 235.921 486.689 235.34 486.109C234.759 485.529 234.432 484.743 234.43 483.922V483.922Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.484 491.727C217.484 491.115 217.666 490.516 218.007 490.007C218.347 489.498 218.831 489.101 219.397 488.866C219.963 488.632 220.587 488.571 221.188 488.69C221.789 488.81 222.341 489.105 222.774 489.538C223.208 489.971 223.503 490.522 223.622 491.123C223.742 491.724 223.681 492.346 223.446 492.912C223.212 493.478 222.814 493.961 222.305 494.301C221.795 494.642 221.196 494.823 220.583 494.823C219.761 494.823 218.973 494.497 218.392 493.916C217.811 493.336 217.484 492.548 217.484 491.727Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7578 350.545H146.347C150.791 350.545 155.054 352.309 158.196 355.449C161.339 358.589 163.105 362.848 163.105 367.289C163.105 371.729 161.339 375.988 158.196 379.128C155.054 382.268 150.791 384.032 146.347 384.032H16.7578C12.3133 384.032 8.05094 382.268 4.90824 379.128C1.76555 375.988 0 371.729 0 367.289H0C0 362.848 1.76555 358.589 4.90824 355.449C8.05094 352.309 12.3133 350.545 16.7578 350.545Z",
  fill: "#DAE3EA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.1229 372.594H86.9817C87.8421 372.594 88.6672 372.935 89.2756 373.543C89.884 374.151 90.2257 374.976 90.2257 375.835V495.761C90.2257 496.621 89.884 497.445 89.2756 498.053C88.6672 498.661 87.8421 499.003 86.9817 499.003H76.1229C75.2625 499.003 74.4374 498.661 73.829 498.053C73.2207 497.445 72.8789 496.621 72.8789 495.761V375.835C72.8789 374.976 73.2207 374.151 73.829 373.543C74.4374 372.935 75.2625 372.594 76.1229 372.594Z",
  fill: "#DAE3EA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.752 460.5H91.3868C92.8041 460.5 94.1634 461.063 95.1656 462.064C96.1678 463.065 96.7308 464.423 96.7308 465.84V494.789C96.7308 495.494 96.5912 496.192 96.32 496.842C96.0487 497.493 95.6513 498.083 95.1505 498.58C94.6497 499.076 94.0556 499.469 93.4023 499.734C92.749 500 92.0494 500.134 91.3441 500.129H71.7094C70.292 500.129 68.9327 499.566 67.9305 498.565C66.9283 497.563 66.3653 496.205 66.3653 494.789V465.84C66.3653 465.135 66.5049 464.437 66.7761 463.786C67.0474 463.136 67.4448 462.545 67.9456 462.049C68.4464 461.552 69.0405 461.16 69.6938 460.894C70.3472 460.628 71.0467 460.494 71.752 460.5Z",
  fill: "#DAE3EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4932 520.745V515.089C16.4932 511.122 18.0707 507.316 20.8788 504.511C23.6869 501.705 27.4955 500.129 31.4668 500.129H81.5523",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.466 520.745V515.089C146.465 513.123 146.076 511.176 145.322 509.36C144.567 507.543 143.462 505.893 142.069 504.504C140.676 503.115 139.023 502.013 137.204 501.262C135.385 500.512 133.435 500.126 131.467 500.129H81.3987",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.0089 520.745V513.921C57.0089 506.304 60.9785 500.129 65.8701 500.129H97.2344C102.126 500.129 106.096 506.304 106.096 513.921V520.745",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.28931 528.95C8.28931 527.329 8.77046 525.744 9.67191 524.396C10.5734 523.048 11.8546 521.997 13.3537 521.377C14.8528 520.757 16.5023 520.594 18.0937 520.911C19.6851 521.227 21.1469 522.008 22.2942 523.154C23.4416 524.3 24.2229 525.761 24.5394 527.351C24.856 528.941 24.6935 530.589 24.0726 532.087C23.4517 533.585 22.4002 534.865 21.051 535.766C19.7019 536.666 18.1158 537.147 16.4932 537.147C14.3181 537.145 12.2327 536.281 10.6947 534.744C9.15663 533.207 8.29157 531.123 8.28931 528.95V528.95Z",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.8051 528.95C48.8051 527.329 49.2862 525.744 50.1877 524.396C51.0891 523.048 52.3704 521.997 53.8695 521.377C55.3685 520.757 57.018 520.594 58.6094 520.911C60.2008 521.227 61.6626 522.008 62.81 523.154C63.9573 524.3 64.7386 525.761 65.0552 527.351C65.3717 528.941 65.2093 530.589 64.5883 532.087C63.9674 533.585 62.9159 534.865 61.5668 535.766C60.2177 536.666 58.6315 537.147 57.0089 537.147C54.8338 537.145 52.7485 536.281 51.2104 534.744C49.6724 533.207 48.8073 531.123 48.8051 528.95V528.95Z",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.096 520.745C107.72 520.743 109.309 521.223 110.661 522.123C112.012 523.024 113.066 524.305 113.689 525.804C114.312 527.303 114.476 528.953 114.16 530.546C113.844 532.138 113.062 533.601 111.914 534.749C110.766 535.898 109.303 536.68 107.71 536.997C106.116 537.315 104.465 537.153 102.963 536.532C101.462 535.911 100.179 534.859 99.2764 533.51C98.3737 532.16 97.8918 530.573 97.8918 528.95C97.8918 526.775 98.7558 524.69 100.294 523.151C101.832 521.612 103.919 520.747 106.096 520.745",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.297 528.95C138.297 527.329 138.778 525.744 139.679 524.396C140.581 523.048 141.862 521.997 143.361 521.377C144.86 520.757 146.51 520.594 148.101 520.911C149.692 521.227 151.154 522.008 152.302 523.154C153.449 524.3 154.23 525.761 154.547 527.351C154.863 528.941 154.701 530.589 154.08 532.087C153.459 533.585 152.408 534.865 151.058 535.766C149.709 536.666 148.123 537.147 146.501 537.147C144.325 537.145 142.24 536.281 140.702 534.744C139.164 533.207 138.299 531.123 138.297 528.95V528.95Z",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.6152 247.542C-30.0923 355.458 74.2704 358.367 110.893 357.829C147.516 357.292 157.154 354.537 167.066 352.14C170.233 361.727 208.196 485.884 208.196 485.884L241.532 475.819C241.532 475.819 216.05 318.09 210.296 307.436C194.495 278.146 101.025 276.559 89.2013 277.267C77.3778 277.975 28.1715 233.86 21.6152 247.542Z",
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.8422 262.289C-10.5771 350.613 141.327 345.291 174.553 335.175C179.521 349.376 220.651 481.381 220.651 481.381",
  stroke: "#8D8D8D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.929 335.337C206.242 333.139 196.611 327.399 189.599 319.046C182.587 310.693 178.605 300.217 178.3 289.32",
  stroke: "#8D8D8D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.162 355.381C156.518 354.593 161.828 353.511 167.066 352.14C168.38 356.115 175.679 379.801 183.764 406.158",
  stroke: "#8D8D8D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.682 333.614C213.899 319.736 211.56 309.842 210.296 307.436C195.442 279.92 111.986 276.849 92.1892 277.173",
  stroke: "#8D8D8D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.936 466.061L205.328 476.51",
  stroke: "#8D8D8D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.2329 80.1994C84.2329 76.7035 85.2705 73.2862 87.2145 70.3797C89.1585 67.4731 91.9215 65.2079 95.1541 63.8705C98.3867 62.5331 101.944 62.1836 105.375 62.8662C108.807 63.5489 111.958 65.2329 114.432 67.7054C116.905 70.178 118.589 73.3278 119.271 76.7567C119.952 80.1855 119.601 83.7393 118.261 86.9686C116.92 90.1978 114.652 92.9574 111.742 94.8983C108.832 96.8393 105.411 97.8744 101.913 97.8727C99.5902 97.8727 97.2905 97.4155 95.1449 96.5272C92.9993 95.639 91.0499 94.337 89.4081 92.6958C87.7663 91.0545 86.4642 89.1062 85.5762 86.962C84.6882 84.8178 84.2317 82.5199 84.2329 80.1994Z",
  fill: "#6A3416"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M251.392 225.689C254.303 223.3 262.191 217.475 264.718 217.509C267.245 217.543 274.894 224.725 275.065 226.61C275.236 228.495 272.803 231.472 271.351 231.685C269.9 231.898 265.231 227.42 264.206 227.821C263.182 228.222 260.928 230.61 260.271 231.668C259.613 232.726 248.49 228.034 251.392 225.689Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.072 178.861L164.539 196.671C164.539 196.671 177.754 168.327 186.957 153.332C185.096 150.654 181.834 139.983 182.253 137.979C182.671 135.974 192.284 117.056 194.606 118.156C196.928 119.256 199.096 122.95 197.909 126.686C199.284 121.764 201.606 114.957 203.655 114.284C205.703 113.61 210.015 114.497 209.827 117.951C210.808 115.691 212.541 114.105 214.522 114.019C216.229 113.942 219.712 115.401 219.951 117.55C220.242 120.237 216.4 126.652 215.931 127.564C217.723 125.125 217.706 125.005 218.782 125.005C220.942 125.082 224.595 128.289 222.811 132.921C221.027 137.552 212.208 159.166 205.379 160.088C205.695 164.284 185.343 222.84 185.343 222.84L154.508 221.612L132.048 191.929L147.072 178.861Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.3244 114.522C29.6143 114.591 10.6625 247.584 16.5871 256.702C20.9323 263.39 72.3752 283.05 90.0038 277.011C96.2271 274.879 112.421 241.656 121.59 208.135C131.365 200.117 149.864 184.934 152.878 182.009C152.024 175.586 137.161 149.707 121.769 138.243C116.451 126.106 106.582 114.522 86.3244 114.522Z",
  fill: "#3B4161"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.991 204.885C100.991 204.885 128.061 239.003 135.181 241.776C142.3 244.548 219.2 243.661 224.817 243.004C230.435 242.347 229.41 246.629 234.49 246.902C239.748 247.192 242.779 242.543 243.496 240.198C246.706 243.763 252.366 249.247 256.079 247.337C258.709 245.972 258.743 244.778 256.933 242.893C259.494 244.369 264.121 246.535 265.99 245.076C268.995 242.739 269.277 240.556 268.261 238.739C265.128 233.118 255.038 225.16 252.639 224.239C249.873 223.147 241.447 226.149 237.392 226.397C219.012 227.531 172.666 216.11 157.462 215.419C155.225 211.154 132.048 183.152 130.255 180.354C123.895 185.787 100.991 204.885 100.991 204.885Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.4356 87.168C93.4339 81.86 95.0078 76.6707 97.9583 72.2566C100.909 67.8424 105.103 64.4017 110.011 62.3696C114.919 60.3376 120.319 59.8055 125.53 60.8406C130.74 61.8757 135.527 64.4316 139.283 68.1849C143.04 71.9383 145.598 76.7204 146.634 81.9265C147.67 87.1326 147.137 92.5288 145.103 97.4324C143.07 102.336 139.626 106.527 135.208 109.475C130.79 112.423 125.596 113.995 120.284 113.994C113.164 113.991 106.336 111.164 101.302 106.134C96.2673 101.104 93.4379 94.2819 93.4356 87.168Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97.0381 81.3253C97.1491 85.4962 88.4074 111.87 84.9585 116.919C86.6659 120.954 103.372 131.07 111.047 128.912C111.901 123.794 114.761 113.507 116.528 111.222C118.295 108.936 96.9271 77.1202 97.0381 81.3253Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M127.728 30.6083C125.176 30.616 122.656 31.1785 120.343 32.2567C118.03 33.3348 115.979 34.9028 114.334 36.8519C112.126 36.02 109.787 35.5868 107.427 35.5725C104.264 35.5275 101.136 36.2321 98.2981 37.6285C95.4603 39.0249 92.9941 41.0733 91.1016 43.6058C89.2091 46.1384 87.9442 49.083 87.4106 52.1983C86.877 55.3136 87.0899 58.5109 88.0317 61.5281C86.8388 62.6247 85.8862 63.9563 85.2339 65.439C84.5815 66.9217 84.2436 68.5233 84.2414 70.143C84.2606 72.9299 85.2513 75.6229 87.0431 77.7588C88.8349 79.8947 91.3157 81.3398 94.0587 81.8456C94.1953 81.1888 94.1953 80.7282 94.4088 79.9776C94.9893 77.9817 103.68 74.331 104.653 74.9878C105.419 75.537 106.291 75.9204 107.214 76.1137C107.294 76.1183 107.373 76.1183 107.453 76.1137C111.062 76.1045 114.603 75.1307 117.709 73.2935C120.815 71.4562 123.372 68.8223 125.116 65.6649C125.987 65.818 126.869 65.9064 127.754 65.9293C127.754 69.4248 128.791 72.8418 130.735 75.7481C132.678 78.6545 135.441 80.9197 138.673 82.2574C141.905 83.595 145.462 83.945 148.893 83.2631C152.324 82.5812 155.476 80.8979 157.949 78.4263C160.423 75.9546 162.108 72.8055 162.79 69.3772C163.473 65.949 163.123 62.3954 161.784 59.1661C160.445 55.9367 158.178 53.1765 155.269 51.2345C152.36 49.2925 148.94 48.256 145.442 48.256C145.439 45.9351 144.978 43.6376 144.086 41.4947C143.194 39.3517 141.888 37.4053 140.243 35.7666C138.598 34.1278 136.646 32.8288 134.499 31.9438C132.352 31.0587 130.051 30.6049 127.728 30.6083Z",
  fill: "#6A3416"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.3158 70.9106C86.3209 68.857 86.935 66.8509 88.0806 65.1458C89.2262 63.4407 90.8519 62.1131 92.7523 61.3307C94.6527 60.5483 96.7426 60.3462 98.7579 60.7499C100.773 61.1537 102.623 62.1452 104.075 63.5991C105.527 65.0531 106.514 66.9042 106.914 68.9188C107.313 70.9334 107.105 73.021 106.318 74.9178C105.53 76.8147 104.197 78.4357 102.488 79.5762C100.778 80.7166 98.7691 81.3253 96.7137 81.3253C95.3461 81.3253 93.9919 81.0557 92.7287 80.532C91.4655 80.0083 90.3181 79.2408 89.3522 78.2734C88.3864 77.3059 87.621 76.1576 87.1 74.8942C86.5789 73.6308 86.3125 72.2771 86.3158 70.9106Z",
  fill: "#F77F89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.9351 251.474C31.8168 234.977 47.5928 173.692 59.3993 155.456",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.8934 169.965C70.6422 175.637 84.2414 200.757 95.7661 209.619C100.163 205.457 131.851 178.477 131.851 178.477C127.805 170.963 108.349 147.404 102.041 141.63",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.799 203.887L127.89 172.438",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.424 130.43C117.16 131.273 116.762 132.068 116.246 132.784C111.721 139.096 98.9674 138.405 87.7585 131.249",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.88 138.303C124.04 143.915 127.002 157.008 125.747 169.538",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.906 187.63L150.248 174.912",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.4167 239.976C78.1547 239.234 104.021 239.763 99.2407 241.383C94.46 243.004 85.5134 244.155 89.5001 245.094C93.3296 245.99 97.2094 246.657 101.119 247.089",
  stroke: "#737999",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.523 87.876C134.259 90.2387 134.779 95.5526 136.564 97.8727",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120.13 84.7371C120.984 82.7156 122.691 81.4959 123.878 82.0162C125.064 82.5365 125.304 84.5751 124.424 86.6136C123.545 88.6522 121.863 89.8549 120.677 89.3346C119.49 88.8143 119.242 86.7672 120.13 84.7371Z",
  fill: "#B5545C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.405 89.3516C141.259 87.3301 142.966 86.1104 144.153 86.6222C145.339 87.1339 145.579 89.181 144.699 91.2196C143.82 93.2582 142.138 94.4609 140.952 93.9406C139.765 93.4202 139.517 91.3646 140.405 89.3516Z",
  fill: "#B5545C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.028 104.193C118.389 103.674 116.94 102.683 115.862 101.345C114.784 100.007 114.125 98.3806 113.967 96.67",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.341 113.542C111.778 112.874 108.387 111.493 105.372 109.482C102.357 107.471 99.7809 104.871 97.7979 101.839",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.342 80.6429C99.1822 81.0793 97.9529 81.3018 96.7137 81.2997C95.7672 81.2994 94.8252 81.1703 93.9136 80.9158",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.7075 77.1713C93.6121 76.8739 92.6218 76.2763 91.8484 75.446C91.075 74.6158 90.5494 73.586 90.3309 72.473C90.1125 71.36 90.2099 70.2082 90.6121 69.1476C91.0144 68.087 91.7055 67.1599 92.6073 66.4711C93.5092 65.7822 94.5858 65.3591 95.7157 65.2495C96.8455 65.1399 97.9835 65.3481 99.0011 65.8507C100.019 66.3533 100.875 67.1303 101.474 68.0937C102.073 69.0572 102.391 70.1688 102.391 71.303",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.103 219.752L157.701 215.419L140.072 192.799",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.423 150.884C198.481 148.581 201.418 143.532 200.402 141.331C199.386 139.13 192.352 136.154 193.214 134.047C194.076 131.94 197.986 126.242 197.986 126.242",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.784 117.934L204.397 128.938",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.187 127.556L211.807 133.765",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.194 224.503L261.013 230.474",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.822 242.535L250.983 237.144",
  stroke: "#B5545C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M221.744 33.7045H231.587C232.048 33.7045 232.441 34.2504 232.441 34.9243V41.057C232.441 41.7309 232.057 42.2682 231.587 42.2682H221.744C221.275 42.2682 220.89 41.7309 220.89 41.057V34.9243C220.899 34.2504 221.275 33.7045 221.744 33.7045Z",
  fill: "#3BB2AC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M236.692 38.3787V42.1488C236.692 42.2597 236.615 42.3024 236.53 42.2512L233.252 40.3832L229.982 38.4982C229.888 38.447 229.888 38.3617 229.982 38.3105L233.252 36.4169L236.53 34.5319C236.546 34.5202 236.565 34.5134 236.585 34.5124C236.605 34.5113 236.624 34.5161 236.642 34.526C236.659 34.536 236.673 34.5507 236.682 34.5684C236.691 34.5861 236.694 34.606 236.692 34.6257V38.3787Z",
  fill: "#3BB2AC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.274 37.9864C214.274 35.1185 215.126 32.315 216.72 29.9304C218.315 27.5459 220.581 25.6873 223.233 24.5898C225.885 23.4923 228.803 23.2052 231.618 23.7647C234.433 24.3242 237.019 25.7052 239.049 27.7331C241.079 29.761 242.461 32.3447 243.021 35.1575C243.581 37.9703 243.293 40.8858 242.195 43.5354C241.096 46.185 239.236 48.4496 236.85 50.0429C234.463 51.6363 231.657 52.4867 228.787 52.4867C224.938 52.4867 221.247 50.959 218.525 48.2397C215.803 45.5203 214.274 41.8321 214.274 37.9864Z",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.8336 2.85297H232.782C235.556 2.85185 238.303 3.39691 240.866 4.457C243.429 5.51709 245.757 7.07142 247.719 9.03117C249.68 10.9909 251.236 13.3176 252.297 15.8784C253.358 18.4391 253.903 21.1837 253.902 23.9552V129.782C253.902 135.379 251.677 140.746 247.716 144.703C243.756 148.661 238.384 150.884 232.782 150.884H24.8336C19.2337 150.882 13.8639 148.658 9.90497 144.7C5.94602 140.743 3.72205 135.377 3.72205 129.782V23.9552C3.72093 21.1844 4.26617 18.4406 5.32662 15.8804C6.38707 13.3202 7.94196 10.9938 9.90246 9.03418C11.863 7.07455 14.1907 5.52004 16.7526 4.45945C19.3145 3.39886 22.0605 2.85297 24.8336 2.85297V2.85297Z",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252.545 16.3895H5.29285",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9005 9.87283C18.8988 9.27864 19.0736 8.69732 19.4028 8.20245C19.732 7.70759 20.2007 7.32143 20.7496 7.09288C21.2985 6.86433 21.903 6.80365 22.4865 6.91853C23.0699 7.03342 23.6062 7.31869 24.0273 7.73825C24.4484 8.1578 24.7354 8.69277 24.8521 9.27541C24.9687 9.85805 24.9097 10.4622 24.6825 11.0113C24.4553 11.5604 24.0702 12.0298 23.5758 12.3601C23.0815 12.6904 22.5002 12.8667 21.9055 12.8667C21.11 12.8667 20.347 12.5516 19.7837 11.9903C19.2204 11.4291 18.9028 10.6676 18.9005 9.87283V9.87283Z",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.7326 9.87283C30.7309 9.27864 30.9057 8.69732 31.2348 8.20246C31.564 7.70759 32.0327 7.32143 32.5816 7.09288C33.1306 6.86433 33.735 6.80365 34.3185 6.91853C34.902 7.03342 35.4382 7.3187 35.8593 7.73825C36.2804 8.1578 36.5675 8.69277 36.6841 9.27541C36.8007 9.85805 36.7417 10.4622 36.5146 11.0113C36.2874 11.5604 35.9022 12.0298 35.4079 12.3601C34.9135 12.6904 34.3322 12.8667 33.7375 12.8667C33.3433 12.8678 32.9527 12.7912 32.5882 12.6413C32.2237 12.4913 31.8924 12.271 31.6132 11.9928C31.3341 11.7147 31.1126 11.3843 30.9615 11.0205C30.8103 10.6567 30.7326 10.2667 30.7326 9.87283V9.87283Z",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.5902 9.87283C42.5885 9.27864 42.7633 8.69732 43.0925 8.20245C43.4217 7.70759 43.8904 7.32143 44.4393 7.09288C44.9882 6.86433 45.5927 6.80365 46.1762 6.91853C46.7596 7.03342 47.2959 7.31869 47.717 7.73825C48.1381 8.1578 48.4251 8.69277 48.5418 9.27541C48.6584 9.85805 48.5994 10.4622 48.3722 11.0113C48.145 11.5604 47.7599 12.0298 47.2655 12.3601C46.7712 12.6904 46.1899 12.8667 45.5952 12.8667C44.7997 12.8667 44.0367 12.5516 43.4734 11.9903C42.9101 11.4291 42.5925 10.6676 42.5902 9.87283V9.87283Z",
  stroke: "#3BB2AC",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415.061 258.041L336.086 500.129",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M479.181 258.041L400.206 500.129",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M479.181 258.041L558.146 500.129",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415.061 258.041L494.026 500.129",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M278.301 100.432H400.71C403.244 100.432 405.673 101.437 407.465 103.227C409.256 105.017 410.263 107.445 410.263 109.976V210.975C410.263 213.507 409.256 215.934 407.465 217.724C405.673 219.514 403.244 220.52 400.71 220.52H278.301C275.77 220.515 273.345 219.508 271.557 217.718C269.769 215.929 268.765 213.504 268.765 210.975V109.976C268.765 107.448 269.769 105.023 271.557 103.233C273.345 101.444 275.77 100.436 278.301 100.432Z",
  fill: "#DAE3EA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M278.301 100.423C277.046 100.422 275.804 100.668 274.645 101.146C273.487 101.625 272.433 102.327 271.546 103.213C270.659 104.099 269.955 105.15 269.475 106.308C268.995 107.465 268.748 108.706 268.748 109.959V210.975C268.759 213.499 269.771 215.916 271.561 217.697C273.351 219.477 275.774 220.477 278.301 220.477H284.438C284.387 219.897 284.251 219.334 284.251 218.771V100.423H278.301Z",
  fill: "#BBC8D4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M322.538 190.743H363.865L387.009 243.337H344.222L322.538 190.743Z",
  fill: "#BBC8D4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M460.596 206.275H494.641V243.337H460.596V206.275Z",
  fill: "#BBC8D4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485.566 224.802C485.566 223.066 486.081 221.369 487.047 219.925C488.012 218.482 489.384 217.357 490.989 216.693C492.594 216.028 494.36 215.855 496.064 216.193C497.768 216.532 499.334 217.368 500.562 218.595C501.791 219.823 502.627 221.387 502.966 223.089C503.305 224.792 503.131 226.557 502.466 228.16C501.801 229.764 500.676 231.135 499.231 232.099C497.786 233.064 496.088 233.579 494.351 233.579C492.021 233.579 489.786 232.654 488.139 231.008C486.492 229.362 485.566 227.129 485.566 224.802V224.802Z",
  stroke: "#BBC8D4",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.596 212.587H494.351",
  stroke: "#DAE3EA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.9446 2.85297H232.893C238.495 2.85297 243.867 5.07623 247.827 9.03367C251.788 12.9911 254.013 18.3585 254.013 23.9552V129.782C254.013 135.379 251.788 140.746 247.827 144.703C243.867 148.661 238.495 150.884 232.893 150.884H24.9446C19.3447 150.882 13.9749 148.658 10.0159 144.7C6.05699 140.743 3.83301 135.377 3.83301 129.782V23.9552C3.83189 21.1844 4.37713 18.4406 5.43758 15.8804C6.49804 13.3202 8.05293 10.9938 10.0134 9.03418C11.9739 7.07455 14.3016 5.52004 16.8636 4.45944C19.4255 3.39885 22.1715 2.85297 24.9446 2.85297Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 247,
  height: 553,
  fill: "white",
  transform: "translate(773)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 559,
  height: 536,
  fill: "white",
  transform: "translate(0 2)"
})));

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 553,
    viewBox: "0 0 1020 553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.9f82983a.svg";
export { ForwardRef as ReactComponent };